import {getBaseUrl} from "@medispend/admin-common/src/env";


export const BASE_URL = getBaseUrl("br");
export const BUSINESS_RULES_LIST_URL = "/api/v1/rules";
export const BUSINESS_RULES_METADATA_URL = "/api/v1/metadata/rules";
export const BUSINESS_RULES_TRIGGERS_URL = "/api/v1/contexts";
